module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-list",
    style: ({
      top: (_vm.isNavClick ? '50px' : '-100%')
    })
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首页")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/intro"
    }
  }, [_vm._v("项目介绍")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/news"
    }
  }, [_vm._v("前沿动态")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/entry"
    }
  }, [_vm._v("会员申请")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("关于我们")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/volunteers"
    }
  }, [_vm._v("志愿者招募")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-210392d2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Nav.vue
// module id = 193
// module chunks = 1